import React, { useEffect, useRef, useState } from 'react';

import styles from './SupportButton.module.css';

export default function Support() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);

  // Detectar si es móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Manejar click en móvil
  const handleMobileClick = (e) => {
    if (isMobile && !isExpanded) {
      e.preventDefault(); // Prevenir que se active el link
      setIsExpanded(true);
    }
  };

  // Cerrar al hacer click fuera (solo móvil)
  useEffect(() => {
    if (!isMobile || !isExpanded) return;

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobile, isExpanded]);

  return (
    <div
      ref={containerRef}
      className={styles['help-button-container']}
      onMouseEnter={() => !isMobile && setIsExpanded(true)}
      onMouseLeave={() => !isMobile && setIsExpanded(false)}
      onClick={handleMobileClick}
    >
      <div className={`${styles['help-button']} ${isExpanded ? styles['expanded'] : ''}`}>
        {!isExpanded && <span className={styles['help-icon']}>?</span>}
        {isExpanded && (
          <div className={styles['help-text']}>
            <p>
              <strong>¿Necesitas ayuda con tu pedido?</strong>
            </p>
            <p>
              Nuestro equipo de Servicio al Cliente está listo para asistirte, solo debes reportar
              tu incidencia con los detalles correspondientes.
            </p>
            👉{' '}
            <a
              href="https://99minutos.zohodesk.com/portal/es/newticket?departmentId=820854000000006907"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()} // Evitar que se cierre al hacer click en el link
            >
              Reporta tu incidencia aquí
            </a>
            .
          </div>
        )}
      </div>
    </div>
  );
}
